var map = {
	"./around-the-world.png": 7,
	"./asm-gergovix.jpg": 8830,
	"./collab_oprod_callout.png": 2574,
	"./gala-chamaliere-2022.jpg": 8843,
	"./hard-cold-trainning.png": 5904,
	"./karl-lewis-king-of-clermont.jpg": 1747,
	"./karl-lewis-sprint.jpg": 4011,
	"./op-kings.png": 9095,
	"./origins-krew-show-2018.jpg": 9782,
	"./origins-krew-training-day.jpg": 9880,
	"./work-dance.jpg": 4828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7281;